/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetLeadAssignmentsRequest
 */
export interface SetLeadAssignmentsRequest {
    /**
     * 
     * @type {string}
     * @memberof SetLeadAssignmentsRequest
     */
    owner_user_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetLeadAssignmentsRequest
     */
    liaison_user_ids: Array<string>;
}

/**
 * Check if a given object implements the SetLeadAssignmentsRequest interface.
 */
export function instanceOfSetLeadAssignmentsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "liaison_user_ids" in value;

    return isInstance;
}

export function SetLeadAssignmentsRequestFromJSON(json: any): SetLeadAssignmentsRequest {
    return SetLeadAssignmentsRequestFromJSONTyped(json, false);
}

export function SetLeadAssignmentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetLeadAssignmentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'owner_user_id': !exists(json, 'owner_user_id') ? undefined : json['owner_user_id'],
        'liaison_user_ids': json['liaison_user_ids'],
    };
}

export function SetLeadAssignmentsRequestToJSON(value?: SetLeadAssignmentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'owner_user_id': value.owner_user_id,
        'liaison_user_ids': value.liaison_user_ids,
    };
}

